<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
        >
        </dx-grid>
        <v-dialog persistent v-model="votingDialog" max-width="1000">
            <voting-master-list-person
                :person="presonInfo"
                :reload="reload"
                :close="closeVotingDialog"
            ></voting-master-list-person>
        </v-dialog>
    </div>
</template>

<script>
import { getDomain } from "../../utils/helpers.js";
import votingMasterListPerson from "./VotingMasterListPerson.vue";

export default {
    components: {
        votingMasterListPerson,
    },
    data: () => ({
        title: "UTA Accounts",
        url: "",
        regID: "",
        actions: [],
        processing: false,
        emailAddress: "",
        emailing: false,
        votingDialog: false,
        presonInfo: {},

        clickedRow: {
            accountID: "",
            newVhStatus: "",
        },

        columns: [
            {
                field: "accountID",
                label: "Account ID",
                format: "",
                //link: "Account View",
                //template: "link-cell-template",
                //template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                },
            },
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstNameH",
                label: "First Name",
                format: "",
                visible: true,
                sortOrder: "asc",
                sortIndex: 1,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastNameH",
                label: "Last Name",
                format: "",
                visible: true,
                sortOrder: "asc",
                sortIndex: 0,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "personID",
                label: "Person ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "votingStatus",
                label: "Voting Status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                field: "father",
                label: "Father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "shver",
                label: "Shver",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Term",
                field: "regID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "emailAddress",
                label: "Email Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "kids",
                label: "Kids",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "applyingKids",
                label: "Applying Kids",
                format: "",
                visible: true,
                type: "number",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.columns.find((c) => c.field == "votingStatus").linkAction = (
            row,
        ) => {
            this.openVotingDialog(row);
        };
    },
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "accountsVotingStatus?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get(
                "api/allStudents/getRegistrationSeasonRegID",
            );
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url = "accountsVotingStatus?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async openVotingDialog(row) {
            if (row.personID == "No Ansl ID") {
                // return this.$notify({
                //     group: "notification",
                //     text: "No Ansl ID",
                //     type: "warning",
                // });

                this.presonInfo = {
                    firstEnglish: row.name,
                    lastEnglish: "",
                    titleHebrew: "",
                    suffixHebrew: "",
                    firstHebrew: row.firstNameH,
                    lastHebrew: row.lastNameH,
                    address1: row.address1,
                    city: "",
                    state: "",
                    zip: "",
                    father: row.father,
                    fatherInLaw: row.shver,
                    parentId: row.accountID,
                };

                this.votingDialog = true;

                return;
            }

            this.presonInfo = await this.$http.get(
                "api/applicantStudents/getPersonByID?personID=" + row.personID,
            );

            this.votingDialog = true;
        },
        closeVotingDialog() {
            this.votingDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
    },
};
</script>
<style></style>
